require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gnie-nuclaire-2-2-2-9.json") })
        }
      }, "path---gnie-nuclaire-2-2-2-9");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gnie-nuclaire-2-2-2-9!./.cache/json/gnie-nuclaire-2-2-2-9.json
// module id = 451
// module chunks = 231608221292675